// extracted by mini-css-extract-plugin
export default {"wrapper":"web-links_wrapper__83rBh","row":"web-links_row__iZaDz","column":"web-links_column__9cSiG"};